import { render, staticRenderFns } from "./AssetActions.vue?vue&type=template&id=0f041634&scoped=true"
import script from "./AssetActions.vue?vue&type=script&lang=js"
export * from "./AssetActions.vue?vue&type=script&lang=js"
import style0 from "./AssetActions.vue?vue&type=style&index=0&id=0f041634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f041634",
  null
  
)

export default component.exports